
/*
 * ACTIONS
 */

export const ACTIVATION_REQUEST = 'Activation/ACTIVATION_REQUEST';
export const ACTIVATION_SUCCESS = 'Activation/ACTIVATION_SUCCESS';
export const ACTIVATION_ERROR   = 'Activation/ACTIVATION_ERROR';
